import React, { useEffect, useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import BarChart from 'components/BarChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByPlatformPerCardType
 * @desc Render % of Chargebacks by Platform (Top 5) chart
 * @filterValues IReportsFilter
 */
const ByPlatformPerCardType = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ [key: string]: number | string }[]>([])
    const [barDataKeys, setBarDataKeys] = useState<[string, number][]>([])

    useEffect(() => {
        setLoading(true)
        ReportsApi.getByCardTypePerPlatform(filterValues).then((data) => {
            setLoading(false)
            data.length ? setData([data[0]]) : setData([])
            setBarDataKeys(data[1])
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const colorPalette =
        clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="% of Chargebacks by Card Type Per Platform (Top 5)">
            <BarChart
                data={data}
                loading={loading}
                valueDataKey="value"
                stackedBarValueKeys={barDataKeys}
                showLegend
                colorPalette={colorPalette}
                //Remove if no showLegend
                height={280}
            />
        </AccentArea>
    )
}

export default ByPlatformPerCardType
